<template>
  <!-- 大转盘 -->
  <div class="lottery-turntable" v-if="cloneComdata.lotteryMode == 'lottery-turntable'">
    <div class="turntable">
      <div class="luckyWheel-frequency"> 今日剩余抽奖次数：0</div>
      <LuckyWheel
        width="340px"
        height="340px"
        :prizes="prizePool"
        :blocks="blocks"
        :buttons="buttons"
        class="LuckyWheel"
        v-show="!isEdit"
      />
      <img
        class="bottom-img"
        src="https://img3.quanyou.com.cn/joyNew/group1/M00/0B/D0/rB8LrmRbU8KAOFi8AAC9G0jbUVQ388.png"
      />
    </div>
  </div>
    <!-- 九宫格 -->
  <div class="box-2" v-else>
    <div class="com-box" >
      <div class="prize-box">
        <div class="prize-item" v-for="(item,index) in prizePool" :key="index">
          <img class="prize-img" :src="item.imgs[0].src" model="widthFix"  alt="" />
          <div class="prize-name">{{item.fonts[0].text}}</div>
        </div>
      </div>
      <div class="btn-box">
        <span class="btn-text">去抽奖</span>
        <span class="number">(剩余0次)</span>
      </div>
      <div class="prize-list">
        <div class="list-head">
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EE/rB8LrWUvmyyASeCKAAACM0Sf2ng753.png" alt="" />
          <span>中奖名单</span>
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EE/rB8LrWUvmyyASeCKAAACM0Sf2ng753.png" alt="" />
        </div>
        <div class="list-item">	当前为预览活动，暂无中奖名单</div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
  data() {
    return {
      blocks: [{ 
        padding: '40px',
        imgs:[{ 
          src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/A3/rB8LrWU3s4KAPUxsAAJbaBKsd5Y565.png',
          width: '375px',
          height: '345px',
          top: '-3px'
        }]
      }],
      buttons: [
        { radius: '37px' },
        { imgs:[{
            src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/19/26/rB8LrWUCyGaAJ14IAAAv3YwRQSk225.png',
            width: '77px',
            height: '79px',
            top: '-55px'
          }]
        }
      ],
    }
  }
}
</script>

<style lang="stylus" scoped>
  .box-2 {
    width: 100%;
    height: 683px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/59/rB8LrmU_FcaAcZ9pAACusRLzgqg955.png');
    background-size: 100% 100%;
    overflow hidden
  }
  .com-box {
    width: 100%;
    height: 589px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/E1/rB8LrWU6GpCAAX19AALGq-9DOVs009.png');
    background-size: 100% 100%;
    margin-top: 80px;
    overflow hidden
    .prize-box {
      display: flex;
		  flex-flow: wrap;
      width: 255px;
      height: 255px;
      margin: auto;
      border-radius: 10px;
      margin-top: 84px;
      .prize-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 85px;
        height: 85px;
        background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/FD/rB8LrWUwhveAOv1EAAAfhJDDusA303.png');
        background-size: 100% 100%;
        .prize-img {
         	width: 50px;
				  height: 42px;
          margin: 8px 0 2px 0;
        }
        .prize-name {
          color: #914B23;
          font-size: 10px;
          font-weight: bold;
          padding: 0 5px 4px 5px;
          box-sizing: border-box;
          text-align: center;
        }
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      width: 202px;
      height: 58px;
      line-height: 48px;
      margin: auto;
      margin-top: 10px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/FC/rB8LrmUwid-AbyA_AACmwA6-q7g382.png');
      background-size: 100% 100%;
      .btn-text {
        color: #9B1824;
        font-size: 18px;
        font-weight: bold; 
      }
      .number {
        color: #9B1824;
        font-size: 14px;
      }
    }
    .prize-list {
      width: 296px;
      height: 126px;
      margin: auto;
      margin-top: 36px;
      border-radius: 10px;
      overflow hidden
      .list-head {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        img {
          width: 14px;
          height: 14px;
        }
        span {
          font-size: 14px;
          color: #fff;
          margin: 0 6px;
        }
      }
      .list-item {
        color: #fff;
        text-align: center;
        margin-top: 20px;
      }
      
    }
  }
.lottery-turntable {
  width: 100%;
  height: 682px;
  background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/9E/rB8LrWVBsCiAR0p3AAE5Bl95I8w896.png');
  background-size: 100% 100%;
  overflow: hidden;
  .turntable {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    height: 660px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/9D/rB8LrmVBshyAL-MuAAMCIG8Rido565.png');
    background-size: 100% 100%;
    .luckyWheel-frequency {
      width: 230px;
      color: #FFFFFF;
      font-size: 13px;
      text-align: center;
      font-weight: bold;
      margin-top: 76px;
    }
    .bottom-img {
      width: 180px;
      height: 59px;
      margin-top: 18px;
    }
  }
}
</style>